import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-caret-up",
  "use": "tamr-icon-caret-up-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-caret-up\"><path d=\"M16,9a2,2,0,0,0-1.4.6l-10,10a2,2,0,0,0,2.8,2.8L16,13.8l8.6,8.6a2,2,0,0,0,2.8-2.8l-10-10A2,2,0,0,0,16,9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol